import { render, staticRenderFns } from "./ProductoList.vue?vue&type=template&id=ddf7aef4&scoped=true&"
import script from "./ProductoList.vue?vue&type=script&lang=js&"
export * from "./ProductoList.vue?vue&type=script&lang=js&"
import style0 from "./ProductoList.vue?vue&type=style&index=0&id=ddf7aef4&scoped=true&lang=css&"
import style1 from "./ProductoList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ProductoList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf7aef4",
  null
  
)

export default component.exports